import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_TIMEZONE } from '../../api/common';
import dayjs from 'dayjs';

@Pipe({
  name: 'ptDate',
  standalone: true,
})
export class PTDatePipe extends DatePipe implements PipeTransform {
  constructor() {
    super('en-US');
  }

  override transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string | null;
  override transform(value: null | undefined, format?: string, timezone?: string, locale?: string): null;
  override transform(value: string | number | Date | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const hasTimezoneInfo = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})/.test(value);
      value = hasTimezoneInfo ? value : `${value}Z`;
    }

    return dayjs(value)
      .tz(timezone ?? DEFAULT_TIMEZONE)
      .format(format ?? 'MM/DD/YYYY');
  }
}
